import { useRepositoryQuery } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

export const useSmartGiftRedemptionUrlQuery = () => {
    const smartGiftEnabled = useFeatureFlag(FeatureFlag.smartgiftIntegration);
    return useRepositoryQuery(
        'voucherRedemption',
        'getConfiguration',
        {},
        {
            enabled: smartGiftEnabled,
        }
    );
};
